<template>
	<div>
		<div class="themebanner" style="background:url(/images/themeBg04.png) center center no-repeat;">
		    <div class="w1200">
		        <div class="themeNews">
		            <ul>
		                <li v-for="(result,index) in topresultDataList">
		                	<img src="/images/new.png" />
		                	<router-link :to="{ name: 'detail', params: { id: result.id }}" :title="result.title" target="_blank" @click.native="$track([['pagetype',colname+'-文章-id:'+result.id+'-点击']])">
		                		{{result.title.length>35?result.title.substring(0,35)+'...':result.title}}<i></i>
		                	</router-link>
		                </li>
		            </ul>
		        </div>
		        <div class="themeTitle">
		            <div class="subTitle">
		                <em>Digital Finance</em>
		                <span>数字金融</span>
		                <img src="/images/line01.png" class="line"/>
		            </div>
		        </div>
		    </div>
		</div>
		<div class="w1200" id="subpageDiv">
			<itemsearch v-bind:colid='colid' v-bind:colname='colname' @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
			<div v-show="!searchResultShow">
				<ul class="tab1">
					<li @click="searchClick('f3510001208345759741346c964f9513','最新动态')" :class="subcolid=='f3510001208345759741346c964f9513'?'curr':''"><span>最新动态</span></li>
					<li @click="searchClick('1209895c26504a3e888c160e79eb9f3f','政策法规')" :class="subcolid=='1209895c26504a3e888c160e79eb9f3f'?'curr':''"><span>政策法规</span></li>
				</ul>
				<div id="con_a_1">
					<el-skeleton :rows="20" :loading="loadingMask" animated>
					<ul class="newList">
						<li v-for="(result,index) in resultDataList" v-if="colid!=subcolid||pageNum!=1||index>2">
							<router-link :to="{ name: 'detail', params: { id: result.id }}" target="_blank" @click.native="$track([['pagetype',colname+'-文章-id:'+result.id+'-点击']])">
								{{result.title}}<i></i>
							</router-link>
							<p>{{result.summary.indexOf('attachment id=')>-1?' ':result.summary}}</p>
							<em>{{result.publishtime?result.publishtime.substring(0,10):''}}</em>
						</li>
					</ul>
					</el-skeleton>
					<div class="pagediv">
						<el-pagination @size-change="changePageSize" @current-change="changeSearchPage" :current-page="pageNum"
							:page-sizes="[10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="totalResultCount">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				loadingMask: true,
				colid: '96eb4f0785c142bb9f95055b725df7cb',
				subcolid: 'f3510001208345759741346c964f9513',
				colname:'数字金融',
				bannerdata:'',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
				topresultDataList: [],
				searchResultShow:false,
				searchKey:'',
			}
		},
		components:{
			itemsearch,
		},
		created: function() {
			// this.bannerfnc();
		},
		mounted: function() {
			document.title = '数字金融-数字中国专版';
			// this.$track([
			// 	['pagetype', '数字金融列表'],
			// 	['reqtype', '2'],
			// 	['column', this.colid]
			// ]);
			this.searchfncTop();
			// this.searchfnc();
			// this.searchClick(this.subcolid);
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			bannerfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'szjjsubject/selecImgtBycolumnID',
						responseType: 'json',
						params: {
							columnID: this.colid,
							attType:2,
						},
					})
					.then(function(response) {
						_this.bannerdata=response.data.data.data.images[_this.colid];
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});
			},
			searchfncTop: function() {
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'szjjsubject/getSubjectColumnArticlesIncludeKB',
						responseType: 'json',
						params: {
							columnID: this.colid,
							iPage: 1,
							pageSize: 3,
							isTopArticle: '2',
						},
					})
					.then(function(response) {
						_this.topresultDataList = response.data.data.data.data;
						_this.searchClick(_this.subcolid);
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				_this.resultDataList = [];
				this.$http({
						method: 'get',
						url: 'szjjsubject/getSubjectColumnArticlesIncludeKB',
						responseType: 'json',
						params: {
							columnID: this.subcolid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			searchClick: function(columnid,columnname) {
				if (columnid) {
					this.subcolid=columnid;
					this.$track([
						['pagetype','数字金融列表'],
						['reqtype','2'],
						['column',this.subcolid]
					]);
					if(columnname){
						this.$track([
							['pagetype',this.colname+'-'+columnname+'-点击'],
						]);
					}
				}
				this.pageNum = 1;
				this.pageSize= 10;
				this.searchfnc();
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = document.getElementById('subpageDiv').offsetTop;
				document.documentElement.scrollTop = document.getElementById('subpageDiv').offsetTop;
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			}
		}
	}
</script>

<style>
</style>
